import { FC } from 'react';
import { Typography } from '@mui/material';

import { ZoneCodeBadge } from '../../../atoms/ZoneCodeBadge';

import { StyledZonesContainer } from './Zones.styled';

/**
 * Whole-network tickets always show the same fixed range, independent of which
 * zones the BE reports as selected — "Zonen A - E (gesamtes Netz)".
 */
const WHOLE_NETWORK_FIRST_ZONE = 'A';
const WHOLE_NETWORK_LAST_ZONE = 'E';

interface IZonesProps {
	zonesLabel: string;
	/** Zone-based tickets: selected zone codes rendered as badges. */
	zoneCodes?: string[];
	/**
	 * BE flag, set when three or more zones were selected
	 */
	isWholeNetwork?: boolean;
	wholeNetworkLabel?: string;
}

/** Renders the zone badges of a zone-based ticket. Nothing without zones. */
export const Zones: FC<IZonesProps> = ({
	zonesLabel,
	zoneCodes,
	isWholeNetwork,
	wholeNetworkLabel,
}) => {
	if (!zoneCodes?.length) {
		return null;
	}

	return (
		<StyledZonesContainer>
			<Typography variant="b1" color="primary.main">
				{zonesLabel}
			</Typography>
			{isWholeNetwork ? (
				<>
					<ZoneCodeBadge code={WHOLE_NETWORK_FIRST_ZONE} />
					<Typography variant="h5-sb" color="primary.main">
						-
					</Typography>
					<ZoneCodeBadge code={WHOLE_NETWORK_LAST_ZONE} />
					<Typography variant="l1" color="solutions.600">
						({wholeNetworkLabel})
					</Typography>
				</>
			) : (
				zoneCodes.map((code, index) => (
					<ZoneCodeBadge key={`${code}-${index}`} code={code} />
				))
			)}
		</StyledZonesContainer>
	);
};
